import PropTypes from "prop-types";
import logo from "@/assets/Landing-Assets/belsoft.png";
import bgImage from "@/assets/VisibilityAssets/market.jpg";
import Button from "./button";

const Hero = ({ heading, subheading }) => {
  return (
    <section className="max-h-[100vh] min-h-[95vh] relative overflow-hidden">
      <div
        className="absolute inset-0 bg-market bg-cover bg-center bg-no-repeat"
        style={{
          filter: "brightness(0.7) saturate(1.1)",
          backgroundImage: `url(${bgImage})`,
        }}
      ></div>
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="absolute top-5 left-5 bg-white/80  p-2 rounded-lg shadow-md z-10">
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "2.5rem",
            height: "auto",
          }}
        />
      </div>

      <div className="relative z-10 flex flex-col items-center min-h-[95vh] justify-center py-10 px-4 text-center text-white">
        <div className="max-w-full">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 opacity-0 animate-fadeUp">
            {heading}
          </h1>
          <p className="text-lg md:text-2xl font-semibold mb-[40px] opacity-0 animate-fadeUp [animation-delay:1s] max-w-3xl mx-auto">
            {subheading}
          </p>
          <a href="#contact-form">
            <Button text="Get Started" />
          </a>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
};

export default Hero;
